import { render, staticRenderFns } from "./ModalNotification.vue?vue&type=template&id=4fda41e0&scoped=true"
import script from "./ModalNotification.vue?vue&type=script&lang=js"
export * from "./ModalNotification.vue?vue&type=script&lang=js"
import style0 from "./ModalNotification.vue?vue&type=style&index=0&id=4fda41e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fda41e0",
  null
  
)

export default component.exports